import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './job-order.reducer';
import { IJobOrder } from 'app/shared/model/job-order.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IJobOrderProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const JobOrder = (props: IJobOrderProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { jobOrderList, match, loading,authorities,visibleJobOrders } = props;

  const filteredJobOrdersList = jobOrderList ?
                                jobOrderList.filter(jobOrder => jobOrder.id && visibleJobOrders.includes(jobOrder.id))
                                .sort((a,b)=> a.jobOrderName >= b.jobOrderName ? 1 : -1) : []

  return (
    <div>
      <h2 id="job-order-heading">
        <Translate contentKey="ordersManagementApp.jobOrder.home.title">Job Orders</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="ordersManagementApp.jobOrder.home.createLabel">Create new Job Order</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {jobOrderList && jobOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">IDgngn</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderName">Job Order Name</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderCode">Job Order Code</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrder.startDate">Start Date</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrder.endDate">End Date</Translate>
                </th>
                <th>
                  <Translate contentKey="ordersManagementApp.jobOrder.jobOrderOwner">Job Order Owner</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {filteredJobOrdersList.map((jobOrder, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${jobOrder.id}`} color="link" size="sm">
                      {jobOrder.id}
                    </Button>
                  </td>
                  <td>{jobOrder.jobOrderName}</td>
                  <td>{jobOrder.jobOrderCode}</td>
                  <td>
                    <TextFormat type="date" value={jobOrder.startDate} format={APP_LOCAL_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={jobOrder.endDate} format={APP_LOCAL_DATE_FORMAT} />
                  </td>
                  <td>
                    {jobOrder.jobOrderOwner ? (
                      <Link to={`job-order-owner/${jobOrder.jobOrderOwner.id}`}>{jobOrder.jobOrderOwner.name} {jobOrder.jobOrderOwner.surname}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${jobOrder.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${jobOrder.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${jobOrder.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="ordersManagementApp.jobOrder.home.notFound">No Job Orders found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ jobOrder,authentication }: IRootState) => ({
  jobOrderList: jobOrder.entities,
  loading: jobOrder.loading,
  visibleJobOrders :authentication.account.visibleJobOrders,
  authorities: authentication.account.authorities
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrder);
